import React from 'react'

const UninstallTheApp = ({ getLangTranslation }) => {
  return (
    <>
      <h3 className='mb-9 mt-6 text-blue-900'>{getLangTranslation("UNINSTALL_APP_CHILD_DEVICE", "Uninstall the app from child's device")}</h3>
      <ul className='timeline'>
        <li>{getLangTranslation("START_APP_CHILD_DEVICE", "Start the app on the child's device")}</li>
        <li>{getLangTranslation("TAP_UNINSTALL_KIDO_PROTECT", "Tap Uninstall Kido Protect")}</li>
        <li>{getLangTranslation("SCRN_OPEN_ENTER_CRED_KIDO_TITLE", "A screen will open for entering the credentials of your Kido Protect account")}</li>
        <li>{getLangTranslation("ENTER_CRED", "Enter the credentials")}</li>
        <li>{getLangTranslation("CLICK_CONTINUE_BTN", "Click on the continue button")}</li>
        <li>{getLangTranslation("AFTER_SUCCESS_AUTHENTIFICATION_KIDO_APP_UNINSTALL", "After the successful authentification, Kido Protect app will be uninstalled from your child's device")}</li>
      </ul>
    </>
  )
}

export default UninstallTheApp